import React, { useEffect, useState, useRef, useContext } from "react";
import { useParams } from 'react-router-dom';
import { Alert } from 'react-bootstrap';
import { BottomActionBar, Chat, Room, TopActionBar } from '../../components';
import { AppRouteUi, CallStatusType, CallType } from '../../configs';
import { ActionCommon, VideoCallContext, useAppSelector, VRIAppStateType, ActionVideoCall } from '../../core';
import { useFunctionalityRoomShareMap } from "../hooks/functionalityRoomShareMap";
import { ModalHangupCall, ModalVideoConferenceLink } from '../../features';
import { searchInCurrentURL } from '../../utils';
import { useVideoCall } from '../hooks';
import { logger, UserMediaUtils } from '../../utils';
import { VideoGuestCall } from "../../components/videoCall/VideoGuestCall";
import { useDispatch } from 'react-redux';
import { RoomShareMapModel } from "../../models/api/Call";
import { ActionAuth, ActionUi, TSliceUi, CallContext } from "../../core";
import { useGuestContext } from "../../core";
//instead of using the socketcontext file for making an API to get a webtoken directly, 
// we will obtain it from a different API (different table) - 
// and so we have to set it ourselves in the store

export function VideoGuestPage() {

    const { isLoading, roomMapData } = useGuestContext();
    const [isCreatingRoom, setIsCreatingRoom] = useState<boolean>(true);
    const [currentState, SetCurrentState] = useState<CallStatusType>(CallStatusType.Zero);

    const audioRef = useRef<HTMLAudioElement>(null);
    const interval = useRef<any>(null);
    const dispatch = useDispatch();

    const { guid } = useParams<{ guid: string }>(); 

    const createVideoCall = async () => {

        console.log("createVideoCall has been invoked");
        audioRef.current?.pause();
        clearTimeout(interval.current);

        const tracks = await UserMediaUtils.startMedia();

        console.log("tracks:", tracks);

        if (tracks) {
            dispatch(ActionVideoCall.setTracks(tracks));
            SetCurrentState(CallStatusType.Received);
            dispatch(
                ActionVideoCall.SetCallStatus({
                    prev: CallStatusType.Zero,
                    current: CallStatusType.Received,
                })
            );
        } else {
            SetCurrentState(CallStatusType.Rejected);
            dispatch(
                ActionVideoCall.SetCallStatus({
                    prev: CallStatusType.Zero,
                    current: CallStatusType.Rejected,
                })
            );
        }
        setIsCreatingRoom(false);
    };

    useEffect(() => {
        createVideoCall();
    }, []);

    // console.log("Rerender of VideoGuestPage. isLoading: " + isLoading + " - isCreatingRoom: " + isCreatingRoom + " - guid: " + guid + " - roomMapData:");
    // console.log(JSON.stringify(roomMapData, null, 2));

    return (
        <>
            {isLoading || isCreatingRoom || !(currentState === CallStatusType.Received) ? (

                <div className="site-call-page ">
                    <div className="site-call-page-wrapper">
                        <div className="container-fluid h-100">
                            <div className="row  justify-content-center align-items-center h-100 Page-call overflow-auto">
                                <div className="col-12 text-center d-flex flex-column align-items-center justify-content-center pt-3">
                                    <p className="text-white">Connecting...</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <>
                    {!roomMapData?.webToken || !roomMapData.roomName ? (
                        <div className="site-call-page ">
                            <div className="site-call-page-wrapper">
                                <div className="container-fluid h-100">
                                    <div className="row  justify-content-center align-items-center h-100 Page-call overflow-auto">
                                        <div className="col-12 text-center d-flex flex-column align-items-center justify-content-center pt-3">
                                            <p className="text-white">Call Parameters are invalid. Please make sure you are accessing an ongoing call.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <VideoGuestCall roomId={roomMapData.roomName} />
                    )
                    }
                </>
            )}

        </>
    );
}
